import type Phaser from 'phaser';

export const COLORS = {
  headerPurple: 0x553089,
  headerPurpleDeep: 0x3b1a73,
  bgLavender: 0xe7e2f9,
  bgMenu: 0xfff3e0,
  bgKitchen: 0xeaf3ff,
  bgOven: 0xfde9d6,
  bgCounter: 0xfff0f5,
  bgDayEnd: 0xe7e2f9,
  accentOrange: 0xf7901e,
  accentPink: 0xea4691,
  accentGreen: 0x4ad17a,
  accentGreenDeep: 0x1f6c3a,
  ink: 0x2a1f4a,
  inkSoft: 0x55488a,
  titleBlue: 0x1f4ec2,
  titleBlueLight: 0x3a8ce8,
  white: 0xffffff,
  shadow: 0x000000,
  burnt: 0x3b2412,
  raw: 0xe5d7ad,
  perfect: 0xc78c4b,
} as const;

const hex = (n: number) => '#' + n.toString(16).padStart(6, '0');

export const DISPLAY_FONT = '"Fredoka", "Comic Sans MS", "Trebuchet MS", sans-serif';
export const MONO_FONT = '"Fredoka", monospace';
export const DIGITAL_FONT = '"VT323", "Courier New", monospace';

export const TextStyles = {
  TITLE: {
    fontFamily: DISPLAY_FONT,
    fontSize: '72px',
    fontStyle: '700',
    color: hex(COLORS.titleBlueLight),
  } satisfies Phaser.Types.GameObjects.Text.TextStyle,
  H1: {
    fontFamily: DISPLAY_FONT,
    fontSize: '46px',
    fontStyle: '700',
    color: hex(COLORS.titleBlue),
  } satisfies Phaser.Types.GameObjects.Text.TextStyle,
  SUBTITLE: {
    fontFamily: DISPLAY_FONT,
    fontSize: '36px',
    fontStyle: 'italic 600',
    color: hex(COLORS.titleBlue),
  } satisfies Phaser.Types.GameObjects.Text.TextStyle,
  BODY: {
    fontFamily: DISPLAY_FONT,
    fontSize: '22px',
    fontStyle: '400',
    color: hex(COLORS.ink),
  } satisfies Phaser.Types.GameObjects.Text.TextStyle,
  LABEL: {
    fontFamily: DISPLAY_FONT,
    fontSize: '20px',
    fontStyle: '500',
    color: hex(COLORS.inkSoft),
  } satisfies Phaser.Types.GameObjects.Text.TextStyle,
  HINT: {
    fontFamily: DISPLAY_FONT,
    fontSize: '18px',
    fontStyle: 'italic 400',
    color: hex(COLORS.inkSoft),
  } satisfies Phaser.Types.GameObjects.Text.TextStyle,
  BUTTON: {
    fontFamily: DISPLAY_FONT,
    fontSize: '26px',
    fontStyle: '600',
    color: hex(COLORS.white),
  } satisfies Phaser.Types.GameObjects.Text.TextStyle,
  BRAND: {
    fontFamily: DISPLAY_FONT,
    fontSize: '30px',
    fontStyle: '700',
    color: hex(COLORS.accentOrange),
  } satisfies Phaser.Types.GameObjects.Text.TextStyle,
  MONO_COUNTER: {
    fontFamily: DIGITAL_FONT,
    fontSize: '38px',
    color: '#f7d96b',
  } satisfies Phaser.Types.GameObjects.Text.TextStyle,
  MONO_CLOCK: {
    fontFamily: DIGITAL_FONT,
    fontSize: '38px',
    color: '#ffe6b3',
  } satisfies Phaser.Types.GameObjects.Text.TextStyle,
} as const;

export const Radii = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  pill: 999,
} as const;

export const Spacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
} as const;
